import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {
  private static authToken: string;

  static SetAuthToken(newToken: string) {
    TokenInterceptor.authToken = newToken;
    // if (!!newToken)
    //   console.log("Got token for future requests: " + TokenInterceptor.authToken);
  }

  static AuthTokenValid(): boolean {
    return !!TokenInterceptor.authToken;
  }

  static Forget(): void {
    TokenInterceptor.authToken = null;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log("In token interceptor");
    if (TokenInterceptor.authToken) {
      // console.log("Adding token header to request");
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${TokenInterceptor.authToken}`
        }
      });
    }
    return next.handle(request);
  }

}
